import axios from './axios/index.js'

import HttpService from './HttpService'
const _http = new HttpService()

export default {
  async getPresignedDocumentURL (payload) {
    const { value } = await _http.post(`/upload/presigned/audiovisual/recording-media/document`, payload)
    return value
  },

  async getPresignedVideoUploadID (payload) {
    const { value } = await _http.post(`/upload/presigned/audiovisual/recording-media/video/start`, payload)
    return value
  },

  async getPresignedVideoURL (payload) {
    const { value } = await _http.post(`/upload/presigned/audiovisual/recording-media/video`, payload)
    return value
  },

  async getPresignedVideoComplete (payload) {
    const { value } = await _http.post(`/upload/presigned/audiovisual/recording-media/video/complete`, payload)
    return value
  },
  
  uploadFile: (url, file, type, onUploadProgress) => {
    return axios.put(
      url,
      file,
      {
        'onUploadProgress': (evt) => { onUploadProgress(evt) }
      })
  }
}